export default "__VITE_ASSET__698a0be8__"